import {
  Column,
  ColumnFilterElementTemplateOptions,
  ColumnProps,
} from 'primereact/column';
import { formatDateAndTime } from '@/utils/formatDate';
import { Row } from 'primereact/row';
import {
  InputDateFilter,
  StatusIndicator,
  TableDropdownFilter,
} from '@/components';
import {
  filterApplyTemplate,
  filterClearTemplate,
} from '@/components/Table/Table';
import { ColumnGroup } from 'primereact/columngroup';
import { TableData } from '@/components/Table/types';
import { DetailedStockInfo } from '../../types';

export const getTableColumns = (
  data: DetailedStockInfo[] | undefined
): ColumnProps[] => {
  return [
    {
      field: 'armador',
      header: 'Armador',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => {
        return (
          <TableDropdownFilter
            options={options}
            data={data as TableData}
            fieldName="armador"
          />
        );
      },
    },
    {
      field: 'tipo',
      header: 'Ti',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'tamano',
      header: 'Ta',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'contenedor',
      header: 'Contenedor',
      filter: true,
      showFilterMenu: true,
      style: { fontWeight: 'bold' },
    },
    {
      field: 'booking',
      header: 'Booking',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'playa',
      header: 'Playa',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => {
        return (
          <TableDropdownFilter
            options={options}
            data={data as TableData}
            fieldName="playa"
          />
        );
      },
    },
    {
      field: 'estado',
      header: 'Estado',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData) => <StatusIndicator status={rowData?.estado} />,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="estado"
        />
      ),
    },
    {
      field: 'tara',
      header: 'Tara (kg)',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'mgw',
      header: 'MGW (kg)',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'payLoad',
      header: 'Payload (Kg)',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },

    {
      field: 'viajeImport',
      header: 'Viaje',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'llegadaImport',
      header: 'LLegada',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData) =>
        rowData.llegadaImport ? formatDateAndTime(rowData.llegadaImport) : '-',
    },
    {
      field: 'viajeExport',
      header: 'Viaje',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'llegadaExport',
      header: 'LLegada',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData) =>
        rowData.llegadaExport ? formatDateAndTime(rowData.llegadaExport) : '-',
    },
    {
      field: 'estadia',
      header: 'Estadía',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'statusExport',
      header: 'Status',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'bloqueos',
      header: 'Bloqueos',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
  ];
};

export const getHeaderColumnsGroup = (
  data: DetailedStockInfo[] | undefined
) => {
  return (
    <ColumnGroup>
      <Row>
        <Column
          header="Armador"
          field="armador"
          filter
          showFilterMenu
          sortable
          rowSpan={3}
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterClear={filterClearTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="armador"
            />
          )}
        />

        <Column
          header="Ti"
          field="tipo"
          rowSpan={3}
          sortable
          showFilterMenu
          filter
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterClear={filterClearTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="tipo"
            />
          )}
        />
        <Column
          header="Ta"
          field="tamano"
          rowSpan={3}
          sortable
          showFilterMenu
          filter
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterClear={filterClearTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="tamano"
            />
          )}
        />

        <Column
          rowSpan={3}
          header="Contenedor"
          field="contenedor"
          filter
          showFilterMenu
          sortable
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="contenedor"
            />
          )}
          filterClear={filterClearTemplate}
        />

        <Column
          rowSpan={3}
          header="Booking"
          field="booking"
          filter
          showFilterMenu
          sortable
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="booking"
            />
          )}
          filterClear={filterClearTemplate}
        />

        <Column
          rowSpan={3}
          header="Playa"
          field="playa"
          filter
          showFilterMenu
          sortable
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="playa"
            />
          )}
          filterClear={filterClearTemplate}
        />

        <Column
          rowSpan={3}
          header="Estado"
          field="estado"
          filter
          showFilterMenu
          sortable
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterClear={filterClearTemplate}
          body={(rowData) => <StatusIndicator status={rowData?.estado} />}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="estado"
            />
          )}
        />
      </Row>
      <Row>
        <Column header="Datos técnicos" colSpan={3} />
        <Column header="Importación" colSpan={2} />
        <Column header="Exportación" colSpan={4} />
        <Column
          header="Bloqueos"
          field="bloqueos"
          sortable
          filter
          showFilterMenu
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="bloqueos"
            />
          )}
          filterClear={filterClearTemplate}
          rowSpan={2}
        />
      </Row>
      <Row>
        <Column
          header="Tara (kg)"
          field="tara"
          sortable
          filter
          showFilterMenu
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="tara"
            />
          )}
          filterClear={filterClearTemplate}
        />
        <Column
          header="MGW (Kg)"
          field="mgw"
          sortable
          filter
          showFilterMenu
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="mgw"
            />
          )}
          filterClear={filterClearTemplate}
        />
        <Column
          header="Payload (Kg)"
          field="payLoad"
          sortable
          filter
          showFilterMenu
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="payLoad"
            />
          )}
          filterClear={filterClearTemplate}
        />

        <Column
          header="Viaje"
          rowSpan={3}
          field="viajeImport"
          filter
          showFilterMenu
          sortable
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="viajeImport"
            />
          )}
          filterClear={filterClearTemplate}
        />
        <Column
          header="Llegada"
          rowSpan={3}
          field="llegadaImport"
          filter
          showFilterMenu
          sortable
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <InputDateFilter options={options} displayMenu />
          )}
          filterClear={filterClearTemplate}
          body={(rowData) =>
            rowData.llegadaImport
              ? formatDateAndTime(rowData.llegadaImport)
              : '-'
          }
          headerStyle={{ minWidth: '12rem' }}
          filterField="llegadaImport"
          dataType="date"
        />
        <Column
          header="Viaje"
          rowSpan={3}
          field="viajeExport"
          filter
          showFilterMenu
          sortable
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="viajeExport"
            />
          )}
          filterClear={filterClearTemplate}
        />
        <Column
          header="Llegada"
          rowSpan={3}
          field="llegadaExport"
          filter
          showFilterMenu
          sortable
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <InputDateFilter options={options} displayMenu />
          )}
          filterClear={filterClearTemplate}
          body={(rowData) =>
            rowData.llegadaExport
              ? formatDateAndTime(rowData.llegadaExport)
              : '-'
          }
          headerStyle={{ minWidth: '12rem' }}
          filterField="llegadaExport"
          dataType="date"
        />
        <Column
          header="Estadía"
          field="estadia"
          sortable
          filter
          showFilterMenu
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="estadia"
            />
          )}
          filterClear={filterClearTemplate}
        />
        <Column
          header="Status"
          field="statusExport"
          sortable
          filter
          showFilterMenu
          showFilterMatchModes={false}
          filterApply={filterApplyTemplate}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <TableDropdownFilter
              options={options}
              data={data as TableData}
              fieldName="statusExport"
            />
          )}
          filterClear={filterClearTemplate}
        />
      </Row>
    </ColumnGroup>
  );
};
